module.exports = __webpack_public_path__ + "static/banner-conteudos-cdcf94054661f929176dd56571990c52.jpg";